import styled from 'threads5/styles/styled';
import { unorderedListStyles } from 'src/styles/mixins/unordered-list-styles';

export const WithUnorderedListStyles = styled('div')(({ theme }) => {
  return {
    ul: unorderedListStyles(theme),
  };
});
